export default "__VITE_ASSET__BUErPXJO__"